export default __webpack_public_path__ + "static/media/Rainbow Word Cloud.fe0a6858.jpg";